import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProjectForm from '../../../projects/containers/ProjectForm';
import PhotoBoothModal from '../../../../containers/PhotoBoothModal';
import { closeAllAnalysisModals } from '../../data/ProjectList/modalActions';
import { updateActiveProject } from '../../../projects/scenes/singleProject/data/projectActions';

class EditProjectModal extends Component {
  constructor(props) {
    super(props);
    this.closeAllModals = this.closeAllModals.bind(this);
    this.updateProject = this.updateProject.bind(this);
  }

  closeAllModals() {
    this.props.dispatch(closeAllAnalysisModals());
  }

  updateProject(project) {
    this.props.dispatch(
      updateActiveProject(project, () => {
        this.closeAllModals();
      })
    );
  }

  render() {
    const project = this.props.projectsList.find(p => p.id === this.props.projectId);
    const projectUnlocked = project && project.template_locked === 1;

    const disabledAttributes = {
      start_date: projectUnlocked,
      end_date: projectUnlocked,
      total_participants: projectUnlocked
    };

    const props = {
      isOpen: this.props.isOpen,
      onRequestClose: this.closeAllModals
    };
    return (
      <PhotoBoothModal {...props}>
        <ProjectForm
          initialValues={project}
          onSubmit={this.updateProject}
          disabledAttributes={disabledAttributes}
        />
      </PhotoBoothModal>
    );
  }
}

export default connect(state => ({
  projectsList: state.projects.list.data,
  projectId: state.analysis.projectsList.analysisModals.projectId
}))(EditProjectModal);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/modals/editProject.js